import React, { useState } from 'react'
import './GameSummary.css'
import HomeHeader from './HomeHeader'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'

const GameSummaryNavigation = (props) => {
	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	/* console.log(
		'GameSummary props: ' + JSON.stringify(props.leagueId)    < - - gameId??
	) */

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='gameSummary-navigation__drawer-nav'>
					{/* <HomeNavLinks leagueId={props.leagueId} /> */}
					<HomeNavLinks />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='gameSummary-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{/* <h1 className='gameSummary-navigation__title'>Game Summary</h1> */}
				<h1
					className='home-navigation__title_gameSummary'
					style={{ textShadow: 'black 2px 2px 2px' }}
				>
					{/* <Link to='/schedule'>Schedules</Link> */}
					Game Summary
				</h1>
				<nav className='gameSummary-navigation__header-nav'>
					{/* <HomeNavLinks leagueId={props.leagueId} /> */}
					<HomeNavLinks />
				</nav>
			</HomeHeader>
		</React.Fragment>
	)
}

export default GameSummaryNavigation
